var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-awe" },
    [
      _c(
        "swiper",
        { ref: "mySwiper", attrs: { options: _vm.swiperOption } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.pagination
        ? _c("div", {
            class: "swiper-pagination swiper-pagination-" + _vm.prevName,
            attrs: { slot: "pagination" },
            slot: "pagination"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.turnPages
        ? _c("div", {
            class: "swiper-button-prev swiper-button-prev-" + _vm.prevName,
            attrs: { slot: "button-prev" },
            slot: "button-prev"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.turnPages
        ? _c("div", {
            class: "swiper-button-next swiper-button-next-" + _vm.nextName,
            attrs: { slot: "button-next" },
            slot: "button-next"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0004fc44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0004fc44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/awesomeSwiper.vue
// module id = /HHP
// module chunks = 2